import apiConnector from '@/epersonam/apiConnector';

const LabelApi = {
  data() {
    return {
      neededlabels: [],
      KEY: 'ADV-LABELS',
      version: 'V3',
    };
  },
  computed: {
    i18nJS() {
      // TODO: requested a refactoring. It must be included in the state.
      return window.i18nJS;
    },
    globalLabels() {
      return this.i18nJS;
    },
    labelKey() {
      return `${this.KEY}-${window.locale}-${this.version}`;
    },
  },
  methods: {
    async setupLabels() {
      this.setInitialLabels();
      const labels = window.AdvLabels.labels;
      const labelsToFind = this.neededlabels.filter((l) => !labels[l]);
      if (labelsToFind.length) {
        let newLabels = await this.getApiLabels(labelsToFind);
        let { labels } = window.AdvLabels;
        window.AdvLabels = {
          labels: {
            ...labels,
            ...newLabels,
          },
          language: window.locale,
        };
        this.setLabelsOni18(newLabels);
        this.setStorageData(window.AdvLabels);
      }
    },

    setLabelsOni18(labels) {
      if (!labels) return;
      for (const [key, value] of Object.entries(labels)) {
        if (!this.i18nJS[key]) {
          this.i18nJS[key] = value;
        }
      }
    },
    async getApiLabels(labelsToFind) {
      try {
        const response = await apiConnector().get(`${window.config.ePersonamService.ePersonamHost}/${window.locale}/labels`, {
          params: { labelsToFind },
        });
        return response.data;
      } catch (e) {
        console.error('qualcosa non ha funzionato nel recupero delle labels( getApiLabels )', e);
      }
    },
    setInitialLabels() {
      if (!window.AdvLabels || window.AdvLabels.language !== window.locale) {
        window.AdvLabels = {};
        window.AdvLabels = this.getStorageData() ?? { labels: '', language: window.locale };
        this.setLabelsOni18(window.AdvLabels.labels);
      }
    },
    setStorageData(value, typeOfStorage = 'local') {
      if (!value) return;
      if (typeof value === 'object') value = JSON.stringify(value);
      typeOfStorage != 'local' ? window.sessionStorage.setItem(this.labelKey, value) : window.localStorage.setItem(this.labelKey, value);
    },
    getStorageData(typeOfStorage = 'local') {
      const value = typeOfStorage != 'local' ? window.sessionStorage.getItem(this.labelKey) : window.localStorage.getItem(this.labelKey);
      try {
        return JSON.parse(value);
      } catch (e) {
        console.error(`qualcosa non ha funzionato( window.${typeOfStorage} )`, e);
      }
    },
  },
};

export { LabelApi };
